/**
 * API 호출 시 로딩 이미지를 표시하지 않을 URL 목록
 *
 * - exact: 정확히 일치하는 URL
 * - startsWith: 특정 경로로 시작하는 URL
 */
export const LOADING_SKIP_URLS = {
  // 정확히 일치하는 URL
  exact: [
    '/api/loginProcess.do',
  ],

  // 특정 경로로 시작하는 URL
  startsWith: [
    // 예: '/api/auth/', '/api/session/'
  ],
};

/**
 * iframe 내부(서버)에서 로딩을 생략할 URL 목록
 * iframe 내부의 axios interceptor에서 사용
 */
export const IFRAME_LOADING_SKIP_URLS = {
  startsWith: [
    '/pms/project/selectActivityList.do',
    '/pms/project/getProject.do',
    '/pms/project/getTask.do',
    '/pms/project/selectGanttList.do',
    '/pms/project/gantt-backend',
    '/onb/mng/member/chat-backend',
    '/pms/base/projectConfig/selectProjectConfigData.do',
    '/insa/mon/totalAlign/selectAuthCheckYn.do',
    '/hcm/report/reportMng/getActualSummary.do',
    '/hcm/report/reportMng/createAiReport.do',
  ],
};

/**
 * URL이 로딩 생략 대상인지 확인 (Nuxt 외부)
 */
export const shouldSkipLoading = (url: string): boolean => {
  // 정확히 일치하는 URL 체크
  if (LOADING_SKIP_URLS.exact.includes(url)) {
    return true;
  }

  // 시작 경로 체크
  for (const prefix of LOADING_SKIP_URLS.startsWith) {
    if (url.startsWith(prefix)) {
      return true;
    }
  }

  return false;
};

/**
 * URL이 로딩 생략 대상인지 확인 (iframe 내부)
 */
export const shouldSkipLoadingInIframe = (url: string): boolean => {
  // 시작 경로 체크
  for (const prefix of IFRAME_LOADING_SKIP_URLS.startsWith) {
    if (url.indexOf(prefix) === 0) {
      return true;
    }
  }

  return false;
};
